import {
  dpr,
  isDebug,
  isMobileApp,
  isPostProcessingDisabled,
} from "@/constants";
import type { User } from "@dndbeyond/auth/types/user";

export const getWorkerName = (
  name: string,
  nodeEnv: string,
  env: string,
  user?: User,
) =>
  JSON.stringify({
    name,
    isDebug,
    isMobileApp,
    isPostProcessingDisabled,
    dpr,
    nodeEnv,
    env,
    ...(user && { user }),
  });
